'use client';

import classnames from 'classnames';
import React, { useRef } from 'react';

import EventListPlaceholder from '@/app/[locale]/(default-layout)/program/_components/EventListPlaceholder';
import ShowingsForTagListItem from '@/app/[locale]/(default-layout)/specials/[showingTagId]/_components/ShowingsForTagListItem';

import { ShowingTagDto } from '@cineamo/api/models/showing-tag/ShowingTagDto.types';

import { CachedContentData } from '@/hooks/useCachedContentData';

type ShowingsForTagListProps = {
    contentsWithShowings: CachedContentData[];
    showingTag: ShowingTagDto;
};

function ShowingsForTagList(props: ShowingsForTagListProps): React.JSX.Element {
    const { showingTag, contentsWithShowings } = props;

    const showingsContainerRef = useRef(null);

    return (
        <div>
            <div
                className={classnames('flex flex-col pb-12 lg:pb-24')}
                ref={showingsContainerRef}>
                {/*{!isFetchingShowingList && !isAllLocationDetailsAvailable() && (*/}
                {/*    <AddCinemasAllowLocationBanner t={t}/>*/}
                {/*)}*/}

                {contentsWithShowings.length === 0 ? (
                    <EventListPlaceholder />
                ) : (
                    contentsWithShowings.map((content) => (
                        <ShowingsForTagListItem
                            key={`ShowingsForTagListItem-${content.id}`}
                            content={content}
                            showingTag={showingTag}
                        />
                    ))
                )}
            </div>
        </div>
    );
}

export default ShowingsForTagList;
